import { MARKETPLACES, isMarketplaceLive } from "./storeConfig";

function MarketplaceLinks({ compact = false, light = false }) {
  return (
    <div className={`flex flex-wrap ${compact ? "gap-2" : "gap-3"}`}>
      {MARKETPLACES.map((shop) => {
        const live = isMarketplaceLive(shop.url);
        return (
          <a
            key={shop.id}
            href={live ? shop.url : "#"}
            target={live ? "_blank" : undefined}
            rel={live ? "noopener noreferrer" : undefined}
            onClick={(event) => {
              if (live) return;
              event.preventDefault();
              window.alert(
                `Paste your ${shop.name} listing URL into storeConfig.js`
              );
            }}
            className={`inline-flex items-center justify-center font-semibold rounded-xl border transition duration-300 ease-in-out ${
              compact ? "py-2 px-3 text-sm" : "text-md py-3 px-5"
            } ${
              light
                ? "bg-white text-black border-white hover:bg-transparent hover:text-white"
                : "bg-black text-white border-gray-700 hover:bg-white hover:text-black"
            }`}
          >
            {compact ? shop.name : `Buy on ${shop.name}`}
          </a>
        );
      })}
    </div>
  );
}

export default MarketplaceLinks;
